import React from "react";
import Paper from "./Paper";
import BusinessCase from "./BusinessCase";
import ExecutiveSummary from "./ExecutiveSummary";
import OpportunityEconomyIndustry from "./OpportunityEconomyIndustry";
import Market from "./Market";
import Product from "./Product";
import Operations from "./Operations";
import Investors from "./Investors";

import ModalExhibit1 from "./ModalExhibit1";
import ModalExhibit2 from "./ModalExhibit2";
import ModalExhibit3 from "./ModalExhibit3";
import ModalExhibit4 from "./ModalExhibit4";
import ModalExhibit5 from "./ModalExhibit5";
import ModalExhibit6 from "./ModalExhibit6";
import ModalExhibit7 from "./ModalExhibit7";

const paperStyle = {
  width: "100%"
};

const Content = ({ ifLoaded, active }) =>
  ((
    {
      "": () => <BusinessCase />,
      "executive-summary": () =>
        ifLoaded(["initialDemand", "activeRound", "customerPreferences", "customerDemands"], ExecutiveSummary),
      "opportunity-economy-industry": () => <OpportunityEconomyIndustry />,
      market: () =>
        ifLoaded(
          [
            "initialDemand",
            "salesClients",
            "customerPreferences",
            "activeRound"
          ],
          Market
        ),
      product: () => ifLoaded(["activeRound"], Product),
      operations: () => ifLoaded(["constants", "activeRound"], Operations),
      investors: () => ifLoaded(["primeRates", "constants", "activeRound", "debtClients"], Investors),
      "modal-exhibit1": () =>
        ifLoaded(
          ["initialDemand", "demandGrowthRate", "goBack"],
          ModalExhibit1
        ),
      "modal-exhibit2": () =>
        ifLoaded(["features", "activeRound", "goBack"], ModalExhibit2),
      "modal-exhibit3": () =>
        ifLoaded(["features", "activeRound", "goBack"], ModalExhibit3),
      "modal-exhibit4": () => ifLoaded(["machines", "goBack"], ModalExhibit4),
      "modal-exhibit5": () =>
        ifLoaded(["debtClients", "goBack"], ModalExhibit5),
      "modal-exhibit6": () => ifLoaded(["ratings", "goBack"], ModalExhibit6),
      "modal-exhibit7": () =>
        ifLoaded(["comparableCompanies", "goBack"], ModalExhibit7)
    }[active] || (() => <Paper style={paperStyle}>Page Not Found</Paper>)
  )());

export default Content;



// WEBPACK FOOTER //
// ./src/components/bcase/Content.js